module.exports = __webpack_public_path__ + "static/img/menu.71dab3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/menu.png
// module id = JkUn
// module chunks = 1